module.exports = __webpack_public_path__ + "static/media/youtube.6d802e73.png";